export class MobileNav {
  constructor() {
    this.DOM = {};
    this.DOM.btn = document.querySelector('.js-header__button');
    this.DOM.closebtn = document.querySelector('.js-mobile-nav__close-button');
    this.DOM.nav = document.querySelector('.js-mobile-nav');
    this.DOM.closecover = document.querySelector('.js-mobile-nav__close-cover');
    this.eventType = this._getEventType();
    this._addEvent();
  }

  _getEventType() {
    const isTouchCapable =
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof DocumentTouch);

    return isTouchCapable ? 'touchstart' : 'click';
  }

  _toggle() {
    this.DOM.nav.classList.toggle('is-mobile-nav__open');
  }

  _addEvent() {
    this.DOM.btn.addEventListener(this.eventType, this._toggle.bind(this));
    this.DOM.closebtn.addEventListener(this.eventType, this._toggle.bind(this));
    this.DOM.closecover.addEventListener(
      this.eventType,
      this._toggle.bind(this)
    );
  }
}
